import i18n from './index.js'
export default {//越南
  translateText: {
    shoppingcart: "giỏ hàng",
    loginorrefisterText: "đăng nhập/đăng ký",
    logoutText: "thoát đăng nhập ",
    personcenterText: "trung tâm cá nhân",
    placeholderText: "hãy chọn",
    loginText: "đăng nhập",
    registerText: "đăng ký",
    emailText: "hộp thư",
    pwdText: "mật khẩu",
    forgetpwdText: "Quên mật mã?",
    nameText: "tên",
    surnameText: "Họ",
    mobileText: "điện thoại",
    setPwdText: "thiết lập mật khẩu",
    countryText: "quốc gia",
    company: "công ty",
    birthday: "Sinh nhật",
    yearText: "năm",
    mouthText: "tháng",
    dayText: "ngày",
    confirmpwdText: "Xác nhận mật khẩu",
    agreeText1: "Tôi đã đọc và đồng ý",
    agreeText2: "Điều kiện sử dụng",
    agreeText3: "và",
    agreeText4: "Tuyên bố riêng tư",
    agreeText5: "Và đồng ý rằng một số thông tin cá nhân của tôi sẽ được xử lý ở nước ngoài dựa trên bản tuyên bố riêng tư.",
    emailplaceholder: 'Xin vui lòng nhập vào hộp thư',
    subscribetitleText: 'Đăng ký tin tức của chúng tôi',
    subscribeText: 'subscribe',
    shareToText: 'chia sẻ đến ',
    searchText: 'tìm kiếm',
    subtractmoneyText: "Giảm tối đa 600",
    magnanimitycouponText: "Phiếu giảm giá đang chờ bạn nhận được",
    drawText: "nhận ngay lập tức",
    discountText: "giảm giá quá nhiều ",
    purchaseText: "mua ngay lập tức",
    composecouponText: "mua kết hợp",
    manyDiscountsText: "Ưu đãi nhiều hơn",
    recommendtitleText: "Đề nghị cho bạn",
    hotsaleproductyitleText: "sản phẩm bán chạy",
    guessLiketitleText: "đoán bạn thích nó.",
    NoDataText: "không có dữ liệu tạm thời",
    appraiseText: "Đánh giá",
    certificate: "phiếu",
    collectText: "bộ sưu tập",
    addCartText: "gia nhập xe đẩy mua hàng",
    enterkeywordsText: "nhập từ khóa",
    useNowText: "dùng ngay lập tức",
    vouchernoText: "số phiếu",
    placeholderyearText: "năm lựa chọn",
    placeholdermouthText: "tháng được chọn",
    placeholderdayText: "ngày lựa chọn",
    // 优惠券页面
    breadcrumbItemText1: 'Siêu',
    breadcrumbItemText2: 'Lớp',
    breadcrumbItemText3: 'Lớn',
    breadcrumbItemText4: 'Phúc',
    breadcrumbItemText5: 'Lợi',
    magnanimitydrawText: 'Rất nhiều phiếu giảm giá đang chờ bạn nhận.',
    availablecouponstitleText: 'Sản phẩm phiếu giảm giá',
    drawbtnText: 'nhận',
    universalText: 'universal universal',
    useText: 'sử dụng',
    limitText: 'Giới hạn',
    fullText: 'đầy',
    subtractText: 'giảm',
    // 折扣
    discountitemText1: 'Giảm giá liên tục ,',
    discountitemText2: 'Juhui liên tiếp',
    // 组合
    commoditydiscountitemText1: 'Kết hợp mua sắm ,',
    commoditydiscountitemText2: 'Cung cấp rất nhiều',
    combinedpriceText: 'giá kết hợp',
    economizeText: 'tiết kiệm',
    buynowText: "mua ngay lập tức",
    // 产品
    ourproductsText: 'sản phẩm của chúng tôi',
    productcategoryText: 'oại sản phẩm',
    recommendtarText: 'khuyến cáo',
    newText: 'sản phẩm mới',
    salesvolumetarText: 'bán hàng',
    pricetarText: 'giá cả ',
    // 博客
    blogmanagementText: "blog nóng",
    latestblogsText: "blog mới nhất",
    relatedrlogsText: "blog liên quan",
    priceIncreasecommentText: "DiJia bình luận",
    commentsectionTtxt: "khu vực bình luận",
    participatingcommentsText: "tham gia bình luận",
    // 论坛
    postingText: "đăng bài",
    topicsText: "chủ đề ",
    replyText: "trả lời",
    viewText: "xem",
    lastreplyText: "trả lời cuối cùng",
    publishText: "publishing",
    placeholdertypeText: "Vui lòng chọn loại chủ đề",
    placeholdertitleText: "Vui lòng nhập tiêu đề",
    placeholdercontentsText: "Vui lòng nhập nội dung",
    fromtopicText: "từ chủ đề：",
    firstfloor: "tầng 1 ",
    floorText: "tòa nhà",
    fromText: "từ：",
    postreplyText: "gửi trả lời",
    // 个人中心 - 我的订单
    myorderText: "đơn đặt hàng của tôi",
    mycommentsText: "lời bình luận của tôi",
    mycollectionText: "bộ sưu tập của tôi",
    couponText: "phiếu giảm giá",
    shippingaddressText: "địa chỉ nhận hàng",
    myPostText: "bài viết của tôi",
    personalinformationText: "thông tin cá nhân",
    editText: "soạn thảo",
    allordersText: "tất cả đơn đặt hàng",
    unpaidText: "chờ trả tiền",
    shippedText: "chờ phát hành",
    receivedText: "nhận hàng",
    evaluatedText: "để được đánh giá",
    baidText: "thanh toán",
    completedText: "đã hoàn thành",
    productinfText: "thông tin sản phẩm",
    unitpricethText: "giá cả",
    quantitythText: "số lượng",
    actualpaymentthText: "thanh toán thực tế",
    transactionstatusthText: "trạng thái giao dịch",
    operationthText: "thao tác",
    ordernumberText: "số thứ tự",
    orderdetailsText: "chi tiết đơn đặt hàng",
    cancelorderText: "hủy lệnh",
    confirmText: "xác nhận",
    cancelText: "hủy bỏ",
    deleteordertitle: "chắc chắn xóa đơn đặt hàng hiện thời?",
    successfultradeText: "giao dịch thành công",
    paymentText: "hanh toán",
    confirmreceiptText: "xác nhận nhận hàng ",
    nncommentText: 'không có lời bình luận',
    // 个人中心 - 我的评论
    productText: "sản phẩm",
    productdetailText: "đánh giá chi tiết",
    replyblogText: "trả lời blog：",
    //个人中心 - 收货地址
    addseliveryaddressText: "thêm địa chỉ nhận hàng",
    addaddresstitleText1: "được lưu",
    addaddresstitleText2: "địa chỉ, vẫn có thể lưu存",
    addaddresstitleText3: "địa chỉ ",
    defaultText: "mặc định",
    consigneeText: "người nhận hàng：",
    addressText: "địa chỉ：",
    fulladdressText: "địa chỉ chi tiết：",
    setdefaultText: "mặc định",
    mobilephoneText: "điện thoại di động：",
    viewmoreText: "em thêm",
    replypostText: "trả lời bài viết：",
    // 个人中心 - 个人信息
    nameLabel: "tên",
    sexlabel: "giới tính",
    modifyavatarText: "sửa đổi avata",
    sexmanText: "nam",
    sexwomanText: "phụ nữ",
    secrecyText: "bảo mật",
    replaceText: "thay thế ",
    saveText: "lưu",
    oldpasswordText: "mật mã gốc",
    newpasswordText: "mật khẩu mới",
    confirmpasswordText: "xác nhận mật khẩu",
    opdpleasolderText: "vui lòng nhập mật khẩu gốc",
    newpleasolderText: "hãy nhập mật khẩu mới",
    unboundText: "không bound",
    bindingText: "bindings",
    unbindingText: "tháo trói",
    // 个人中心-个人信息
    regionText: "khu vực",
    addconsigneleasolderText: "hãy đến rồi điền vào chúng ShouHuoRen",
    countrypleasolderText: "hãy chọn quốc gia",
    provinceleasolderText: "hãy chọn tỉnh",
    citypleasolderText: "Hãy chọn khu vực",
    areapleasolderText: "Hãy chọn khu vực",
    fulladdressTextpleasolderText: "hãy nhập vào địa chỉ chi tiết",
    addconsignephoneleasolderText: "hãy đến rồi điền vào chúng ShouHuoRen",
    emailpleasolderText: "hãy nhập địa chỉ email",
    phoneText: 'số điện thoại',
    uploadimgText: " upload pictures",
    updateuserface: "thay đổi avatar",
    uploadimgtitle1: "Hỗ trợ hình ảnh dạng JPG, jpeg, PNG",
    uploadimgtitle2: "Kích thước được đề nghị: 200*200 hoặc tương đương hình ảnh",
    updateemailText: "thay đổi hộp thư",
    updatemobileText: "Thay đổi số điện thoại di động",
    dialogemailtitle: "địa chỉ email ",
    dialogmobiletitle: " số điện thoại di động",
    dialogheadertitle: " nhập liên kết với tài khoản kam của bạn",
    continueText: " tiếp tục",
    verificationinformation: "thông tin xác minh",
    verificationinformationTitle1: "muốn tiếp tục, xin hãy đây xác nhận hoàn thành các bước. Chúng ta đã đi đến ",
    verificationinformationTitle2: "đã gửi captcha. Hãy nhập vào đây. Này。",
    verificationcode: "captcha",
    newtitle: "mới",
    dialognewmobiletitle: "nhập số điện thoại mới cần liên kết. Và nhấn xác nhận thay thế",
    confirmpbtnText: "xác nhận",
    titlecpuntryselect: " chọn quốc gia",
    hotcountrytitle: " hotcountry",
    aboutusText: " về chúng tôi",
    // 订单详情
    havequestionsText: "có câu hỏi",
    preferentialText: "ưu đãi",
    enquiryText: "xunJia",
    combinationdiscountText: "kết hợp ưu đãi ",
    introduceText: "giới thiệu",
    buyermycommentsText: "người mua bình luận",
    starText: "ngôi SAO",
    yourmailboxText: "hộp thư của bạn ",
    placeholderquestionText: " hãy viết câu hỏi của bạn",
    uploadimglimtText: " xin tải tập tin JPG/GIF/PNG. Hình ảnh không thể lớn hơn 2MB.",
    submitbtnText: "nộp",
    // 购物车
    selectText: "chọn",
    tipscartsText: "Sản phẩm đã chọn (không bao gồm chi phí vận chuyển)",
    settlementText: "Giải quyết",
    selectallText: "tất cả",
    amountText: "số tiền",
    addtofavoritesText: "thêm vào favorites",
    havecollectedText: " đã sưu tập",
    tipdelecteproduct: " xác định xóa hàng hóa hiện tại?",
    deleteText: "xóa",
    tipclearcart: "dọn sạch xe đẩy?",
    clearcartText: "dọn sạch xe đẩy",
    totalText: " tổng số",
    totaltipText: "hàng hóa (không bao gồm vận chuyển hàng hóa):",


    pieceText: " mảnh",
    freightText: " vận chuyển hàng hóa :",
    taxationText: " thuế :",
    fullreductionamountText: " số lượng giảm ",
    amountpayableText: " số tiền phải trả :",
    confirmorderText: " xác nhận đơn đặt hàng",
    paymentshouldText: " thành công thanh toán ",
    receivinginformationText: "nên hãy thông tin",
    othershippingaddressText: "những địa chỉ nên hãy khác",
    addshippingaddressText: " thêm địa chỉ nhận hàng ",
    selectshippingaddressText: "lựa chọn địa chỉ nên hãy",
    selfprimingText: "điểm",
    typeofshippingText: " phương pháp vận chuyển ",
    inquirecostsText: " hãy nhấp vào đây để hỏi về vận chuyển hàng hóa ",
    confirmproductinformationText: "xác nhận thông tin sản phẩm",
    settlementinformationText: "tra giỏ thông tin",
    clipcoupons: "sử dụng phiếu giảm",
    AllitemsText: " tất cả hàng hóa ",
    validtoText: " hết hạn Sản phẩm ",
    pieceproductTotal: "Một điều đặt hàng Tổng số:",
    placeorder: " gửi đơn",
    consultText: " tư vấn ",
    consultationText: " hãy nhập nội dung tư vấn ",
    sendoutText: " gửi đi ",
    enterproductname: " nhập tên sản phẩm ",
    contentText: " nội dung ",
    filerestrictionsText: "Hãy tải lên tập tin JPG/GIF/PNG. Ảnh không thể lớn hơn 2MB",
    withaccountText:"Nhập địa chỉ email liên kết với tài khoản kam của bạn",
    pagelostText:"Tôi rất tiếc, trang mà anh đã truy cập đã bị mất liên lạc",
    pagelostText1:"Tự động nhảy vào trang trên trong giây, nếu không nhảy, hãy nhấn nút Để tải",
    pagelostText2:"Để tải",
    pagelostText3:"Trở về trang chủ",
    verificationrequiredText:"Cần phải xác minh",
    continuestepemailText:"Để tiếp tục, hãy hoàn thành bước xác nhận này. Chúng tôi đã gửi email",
    sendcodeText:"Gửi captcha. Hãy nhập vào đây.",
    resendverificationcodeText:"",
    createnewpasswordText:"Gửi lại captcha",
    providepasswordText:"Bạn cần phải cung cấp mật khẩu này mỗi lần bạn đăng nhập.",
    savechangeText:"Lưu các thay đổi và đăng nhập",
    shareToText1: 'follow us  on',
    productDetailsText:"Chi tiết sản phẩm",
    signedforText:"Đã đăng ký",
    rejectionText:"lý",
    evaluated1Text:"Đã được đánh giá",
    reviewedText:"Chờ xem xét",
    PaidText:"Thanh toán",
    subtotalText:"Kế hoạch nhỏ",
    waitingforpaymentText:"Chờ thanh toán",
    automaticclosingText:"Để thanh toán, lệnh thời gian sẽ tự động đóng cửa",
    patientText:"Khách hàng thân mến, đơn đặt hàng của bạn là ra khỏi kho, xin vui lòng kiên nhẫn chờ đợi.",
    consigneeinformationText:"Thông tin người nhận hàng",
    paymentinformationText:"Thông tin thanh toán",
    paymentmethodText:"Hình thức thanh toán:",
    paymenttimeText:"Thời gian thanh toán:",
    fullnameText:"Tên đầy đủ",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_vi.js